export default "__VITE_ASSET__f3DPbyoS__"